export default function replaceMacros(queryParams, text) {
    if (!queryParams || !text) return text;
    return text.replace(/\$\[([^\]]+)\]/g, (match, macroName) => (queryParams[macroName] || ''));
}



// WEBPACK FOOTER //
// ./src/lib/replace-macros.jsx